import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DisclaimerPopup from "./components/DisclaimerPopup";

import Home from "./pages/Home";
import OurTeam from "./pages/OurTeam";
import Contact from "./pages/Contact";
import PracticeArea from "./pages/PracticeArea";
import Blog from "./pages/blog";
import BlogPost from "./pages/BlogPost"; // individual blog detail page

// Theme customization
const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#9c27b0" },
  },
});

function App() {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("disclaimerAccepted");
    if (accepted) {
      setDisclaimerAccepted(true);
    }
  }, []);

  const handleAcceptDisclaimer = () => {
    localStorage.setItem("disclaimerAccepted", "true");
    setDisclaimerAccepted(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        {!disclaimerAccepted && (
          <DisclaimerPopup onAccept={handleAcceptDisclaimer} />
        )}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/practicearea" element={<PracticeArea />} />
          <Route path="/ourteam" element={<OurTeam />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} /> {/* Individual Blog Page */}
        </Routes>

        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
